import { LanguagesEnum } from 'common/enums/languages'

export const data: Record<LanguagesEnum, { title: string; description: string }> = {
  [LanguagesEnum.PT_BR]: {
    title: 'Algo deu errado',
    description: 'Não foi possível carregar esta página. Volte e tente novamente.',
  },
  [LanguagesEnum.EN_US]: {
    title: 'Something went wrong',
    description: 'We could not load this page. Please go back and try again.',
  },
  [LanguagesEnum.ES_ES]: {
    title: 'Algo salió mal',
    description: 'No fue posible cargar esta página. Vuelve e inténtalo de nuevo.',
  },
}
